import {
  OPTIMIZELY_EXPERIMENT_CONTROL,
  OPTIMIZELY_EXPERIMENT_OPTIONS,
  type OpzlyExperimentConfigOption,
} from '@/modules/experiments/types.ts';

/**
 * Checks if the given string value is a valid experiment option.
 *
 * @param {string} value - The value to be checked.
 * @return {boolean} True if the value is a valid experiment option; otherwise, false.
 */
export function isExperimentOption(
  value: string
): value is OpzlyExperimentConfigOption {
  return (
    OPTIMIZELY_EXPERIMENT_OPTIONS.includes(
      value as OpzlyExperimentConfigOption
    ) || value === OPTIMIZELY_EXPERIMENT_CONTROL
  );
}
